import React from "react";
import DataTableDuracionEntrevistaIeC from "../DataTable/DataTableDuracionEntrevistaIeC";


const DuracionEntrevistaTotalIeC = () => {
  return (
    <section className="section-container">
      <DataTableDuracionEntrevistaIeC/>
    </section>
  );
};

export default DuracionEntrevistaTotalIeC;
